<template>
  <div v-if="result" id="contents" class="order contents">
    <div class="orderComplete">
      <h2>
        {{
          isEventProduct
            ? $t('order.application_completed')
            : $t('order.purchase_completed')
        }}
        <span>{{ result.desc }}</span>
      </h2>
      <div>
        <dl>
          <dt>{{ $t('order.total_product_amount') }}</dt>
          <dd>{{ result.displayPrice.addComma() }}{{ result.currencyUnit }}</dd>
        </dl>
        <dl>
          <dt>{{ $t('order.discount_amount') }}</dt>
          <dd>-{{ befefit.addComma() }}{{ result.currencyUnit }}</dd>
        </dl>
        <dl>
          <dt>{{ $t('order.total_payment_amount') }}</dt>
          <dd>{{ result.totalPrice.addComma() }}{{ result.currencyUnit }}</dd>
        </dl>
      </div>
    </div>
    <div class="orderPayInfo">
      <h2>{{ $t('order.payment_information') }}</h2>
      <div>
        <dl>
          <dt>{{ result.paymentTypeName }}</dt>
          <dd>
            {{ result.totalPrice.addComma() }}{{ result.currencyUnit }}
            <span class="date">({{ currentDate }})</span>
          </dd>
        </dl>
        <p v-if="result.paymentType === 2">
          ※ {{ $t('order.cash_receipt_info_in_purchase_history') }}
        </p>
      </div>
    </div>
    <div class="orderBtSec">
      <button type="button" class="button53" @click="handleClick('/main')">
        {{ $t('order.continue_shopping') }}
      </button>
      <button
        v-if="isShippingProduct || isEventProduct"
        type="button"
        class="button52"
        @click="$router.replace(`/purchaseView/${result.purchaseId}`)"
      >
        {{ $t('order.view_order_details') }}
      </button>
      <button
        v-else
        type="button"
        class="button52"
        @click="handleClick('/coupon')"
      >
        {{ $t('order.go_to_my_coupons') }}
      </button>
    </div>
  </div>
</template>

<script>
import { beforeSendLog } from '@/utils'
import PaymentAPI from '@/api/payment'

export default {
  name: 'OrderComplete',
  props: {
    token: {
      type: String,
      default: ''
    },
    isShippingProduct: {
      type: Boolean,
      default: false
    },
    isEventProduct: {
      type: Boolean,
      default: false
    },
    productType: {
      type: String,
      default: undefined
    }
  },
  data() {
    return {
      result: null,
      paymentType: {
        1: this.$t('status.payment.kakaopay'),
        2: this.$t('status.payment.tosspay'),
        3: this.$t('status.payment.payco'),
        4: this.$t('status.payment.cultural_voucher'),
        5: this.$t('status.payment.credit_card')
      }
    }
  },
  computed: {
    befefit() {
      const { totalPrice, displayPrice } = this.result
      return displayPrice - totalPrice
    },
    currentDate() {
      if (this.result.currentDate) {
        const date = new Date()
        return `${date.getFullYear()}${this.$t(
          'common.unit.unit_year_G10'
        )} ${date.getMonth() + 1}${this.$t(
          'common.unit.unit_month_G11'
        )} ${date.getDate()}${this.$t('common.unit.unit_day_G12')}`
      } else {
        return ''
      }
    }
  },
  methods: {
    handleClick(path) {
      if (path === '/main') {
        beforeSendLog(
          'Continue',
          this.isShippingProduct ? { ProductType: this.productType } : undefined
        )
      } else if (path === '/coupon') {
        beforeSendLog('MyCoupon')
      } else {
        // purchaseView/${result.purchaseId}
        beforeSendLog('Detail')
      }

      this.$router.replace(path)
    }
  },
  mounted() {},
  beforeRouteEnter(to, from, next) {
    const { result, token } = to.params
    if (result) {
      next(vm => vm.$set(vm, 'result', result))
    } else {
      PaymentAPI.getPaymentResult(token, responseData => {
        if (responseData.code === 0) {
          next(vm => vm.$set(vm, 'result', responseData.data))
        } else {
          next(vm => {
            const { name } = from
            vm.$router.replace(
              name === 'order' || !name ? { name: 'main' } : { name }
            )
          })
        }
      })
    }
  }
}
</script>

<style lang="scss">
.order {
  .orderComplete {
    // padding: 0 16px;
    background-color: #fff;
    border-bottom: 1px solid #d6d6db;
    h2 {
      height: 146px;
      padding-top: 54px;
      font-weight: bold;
      font-size: 17px;
      text-align: center;
      span {
        display: block;
        padding-top: 11px;
        font-weight: normal;
        font-size: 14px;
      }
    }
  }
  .orderPayInfo {
    dl {
      position: relative;
      padding: 13px 16px 11px 80px;
      text-align: right;
    }
    dt {
      position: absolute;
      top: 18px;
      left: 14px;
      width: auto;
      font-size: 14px;
    }
    dd {
      width: auto;
      display: inline-block;
      text-align: left;
      font-size: 14px;
      line-height: 24px;
      color: #151721;
      font-weight: bold;
      .date {
        font-size: 12px;
        color: #636376;
      }
      span {
        font-weight: normal;
      }
    }
    p {
      padding: 0 14px 16px;
      font-size: 11px;
      color: #636376;
    }
  }
}
</style>
